/**
 * Payload za POST /cso/add i POST /public-body/add.
 * BE Jackson koristi snake_case u JSON-u (register_id, registration_number).
 */
import { getFirstRegisterId } from '@/shared/utils/registry/registerUtils';

/** Placeholder MBR kada korisnik ne unosi matični broj (BE zahteva polje). */
export const DEFAULT_REGISTRATION_NUMBER = '000000000';

export const ORGANIZATION_REGISTER_UNAVAILABLE_MESSAGE =
  'Нема доступних регистара. Молимо контактирајте администратора.';

/**
 * Dopunjava register_id (prvi aktivni iz šifarnika) i registration_number (placeholder)
 * kada nisu prosleđeni u formi.
 * @param {object} data
 * @param {() => Promise<Array<{ id?: string }>>} getActiveRegisters
 * @returns {Promise<{ registerId: string, registrationNumber: string }>}
 */
export async function resolveOrganizationAddDefaults(data, getActiveRegisters) {
  const registerId = data.register_id?.trim() || data.registerId?.trim() || '';
  const registrationNumber =
    data.registration_number?.trim() || data.registrationNumber?.trim() || '';

  let resolvedRegisterId = registerId;
  if (!resolvedRegisterId) {
    const registers = await getActiveRegisters();
    resolvedRegisterId = getFirstRegisterId(registers);
  }

  if (!resolvedRegisterId) {
    throw new Error(ORGANIZATION_REGISTER_UNAVAILABLE_MESSAGE);
  }

  return {
    registerId: resolvedRegisterId,
    registrationNumber: registrationNumber || DEFAULT_REGISTRATION_NUMBER,
  };
}

/**
 * @param {object} data
 * @param {{ registerId?: string, registrationNumber?: string }} [defaults]
 * @returns {{ name: string, register_id?: string, registration_number?: string }}
 */
export function buildOrganizationAddApiBody(data, defaults = {}) {
  const register_id =
    data.register_id?.trim() ||
    data.registerId?.trim() ||
    defaults.registerId ||
    '';
  const registration_number =
    data.registration_number?.trim() ||
    data.registrationNumber?.trim() ||
    defaults.registrationNumber ||
    '';

  const body = { name: data.name.trim() };
  if (register_id) body.register_id = register_id;
  if (registration_number) body.registration_number = registration_number;
  return body;
}
